import { useState, useEffect, useCallback } from 'react';

import { useSelector } from 'react-redux';

import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import { useStatsigGate } from 'src/contexts/feature-provider';
import { getCurrentWorkspaceExtraAttributes } from 'src/selectors/workspace-selectors';
import store from 'src/utils/store';

const GPG_SPOTLIGHT_MODAL = 'gpg-spotlight-modal' as const;

const getGPGSpotlightModalDismissed = (): boolean => {
  return store.get(GPG_SPOTLIGHT_MODAL);
};

type UseGpgSpotlightReturn = [boolean, () => void];

const useGpgSpotlight = (): UseGpgSpotlightReturn => {
  const { hasPremium = false } = useSelector(
    getCurrentWorkspaceExtraAttributes
  );
  const [showGpgSpotlight, setShowGpgSpotlight] = useState(false);
  const hasGpgKeyFeature = useStatsigGate(StatsigFeatureKeys.gpgKeysUi);
  const hasGpgKeySpotlight = useStatsigGate(
    StatsigFeatureKeys.gpgKeysSpotlight
  );

  useEffect(() => {
    const hasUserDismissed = getGPGSpotlightModalDismissed();
    setShowGpgSpotlight(
      hasGpgKeyFeature && hasGpgKeySpotlight && hasPremium && !hasUserDismissed
    );
  }, [hasGpgKeyFeature, hasPremium, hasGpgKeySpotlight]);

  const handleDismiss = useCallback(() => {
    store.set(GPG_SPOTLIGHT_MODAL, true);
    setShowGpgSpotlight(false);
  }, []);

  return [showGpgSpotlight, handleDismiss];
};

export default useGpgSpotlight;
